export const DATA_TYPES = [
  "integer",
  "string",
  "number",
  "float",
  "boolean",
  "date",
  "datetime",
  "currency",
  "percentage",
  "object",
  "array",
];